import { render, staticRenderFns } from "./information-parent.vue?vue&type=template&id=97133d0a&scoped=true&"
import script from "./information-parent.vue?vue&type=script&lang=ts&"
export * from "./information-parent.vue?vue&type=script&lang=ts&"
import style0 from "./information-parent.vue?vue&type=style&index=0&id=97133d0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97133d0a",
  null
  
)

export default component.exports